"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "changeEmail", {
  enumerable: true,
  get: function get() {
    return _commands.changeEmail;
  }
});
Object.defineProperty(exports, "confirmEmail", {
  enumerable: true,
  get: function get() {
    return _commands.confirmEmail;
  }
});
Object.defineProperty(exports, "createUserRequestAction", {
  enumerable: true,
  get: function get() {
    return _slice.createUserRequestAction;
  }
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _view["default"];
  }
});
Object.defineProperty(exports, "getIdentificationData", {
  enumerable: true,
  get: function get() {
    return _commands.getIdentificationData;
  }
});
Object.defineProperty(exports, "getMerchantUsers", {
  enumerable: true,
  get: function get() {
    return _commands.getMerchantUsers;
  }
});
Object.defineProperty(exports, "getOptionsData", {
  enumerable: true,
  get: function get() {
    return _commands.getOptionsData;
  }
});
Object.defineProperty(exports, "initialConfirmEmail", {
  enumerable: true,
  get: function get() {
    return _commands.initialConfirmEmail;
  }
});
Object.defineProperty(exports, "name", {
  enumerable: true,
  get: function get() {
    return _slice.name;
  }
});
Object.defineProperty(exports, "reducer", {
  enumerable: true,
  get: function get() {
    return _slice.reducer;
  }
});
Object.defineProperty(exports, "removeUserDataById", {
  enumerable: true,
  get: function get() {
    return _commands.removeUserDataById;
  }
});
Object.defineProperty(exports, "resetStateAction", {
  enumerable: true,
  get: function get() {
    return _slice.resetStateAction;
  }
});
Object.defineProperty(exports, "selectError", {
  enumerable: true,
  get: function get() {
    return _slice.selectError;
  }
});
Object.defineProperty(exports, "selectIdentificationData", {
  enumerable: true,
  get: function get() {
    return _slice.selectIdentificationData;
  }
});
Object.defineProperty(exports, "selectIdentificationInProcess", {
  enumerable: true,
  get: function get() {
    return _slice.selectIdentificationInProcess;
  }
});
Object.defineProperty(exports, "selectInProcess", {
  enumerable: true,
  get: function get() {
    return _slice.selectInProcess;
  }
});
Object.defineProperty(exports, "selectPreloadingProcess", {
  enumerable: true,
  get: function get() {
    return _slice.selectPreloadingProcess;
  }
});
Object.defineProperty(exports, "selectUser", {
  enumerable: true,
  get: function get() {
    return _slice.selectUser;
  }
});
Object.defineProperty(exports, "selectUsers", {
  enumerable: true,
  get: function get() {
    return _slice.selectUsers;
  }
});
Object.defineProperty(exports, "setPreloadingProcess", {
  enumerable: true,
  get: function get() {
    return _slice.setPreloadingProcess;
  }
});
Object.defineProperty(exports, "updateIdentification", {
  enumerable: true,
  get: function get() {
    return _commands.updateIdentification;
  }
});
Object.defineProperty(exports, "updateLegal", {
  enumerable: true,
  get: function get() {
    return _commands.updateLegal;
  }
});

var _view = _interopRequireDefault(require("./view"));

var _slice = require("./store/slice");

var _commands = require("./store/commands");